import React, { Component } from 'react';
import { connect } from 'react-redux';
import routes from '../Constants/Routes';

// Guard for private routes. Without a session the user is sent to the login page, with the page
// they wanted as the return path. It used to flag "Access denied." and open the sign-in modal on
// top of the home page; since the login page became the landing place for signed-out users, that
// modal stacked over the login form (sign-out, expired session, bookmarks, "My Listings" links).
export default function (ComposedComponent) {
  class Authentication extends Component {
    componentWillMount() {
      if (!this.props.authenticated) {
        this.redirectToLogin(this.props);
      }
    }

    componentWillUpdate(nextProps) {
      if (!nextProps.authenticated) {
        this.redirectToLogin(nextProps);
      }
    }

    redirectToLogin(props) {
      props.history.replace({ pathname: routes.SIGN_IN, state: { from: props.location } });
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return { authenticated: state.user.userDetails.token };
  }
  return connect(mapStateToProps)(Authentication);
}
